<div class="panel-group">
  <div class="panel panel-default">
    <!-- <div class="panel-heading">
      <h2 class="panel-title col-sm-11">
        <a (click) = "changeStatusPanel()" data-toggle="collapse"> {{labelTitle ? labelTitle : 'Ricerca ruolo'}} <span *ngIf="required" class="mandatory ">*</span></a>
      </h2>
      <a (click) = "changeStatusPanel()" data-toggle="collapse" aria-expanded="openPanel" >
        <span *ngIf="!openPanel" class="glyphicon glyphicon-triangle-bottom" ></span>
        <span *ngIf="openPanel" class="glyphicon glyphicon-triangle-top" ></span>
      </a>
    </div> -->

    <div class="panel-heading">
      <div class="row">
        <h2 class="panel-title col-xs-10">
          <a (click) = "changeStatusPanel()" data-toggle="collapse"> {{labelTitle ? labelTitle : 'Ricerca ruolo'}} <span *ngIf="required" class="mandatory ">*</span></a>
        </h2>
        <div class="col-xs-2">
          <a (click) = "changeStatusPanel()" data-toggle="collapse" aria-expanded="openPanel" >
            <span *ngIf="!openPanel" class="glyphicon glyphicon-triangle-bottom" ></span>
            <span *ngIf="openPanel" class="glyphicon glyphicon-triangle-top" ></span>
          </a>
        </div>
      </div>
    </div>

    <div   id="collapse1" class="{{openPanel ? 'panel-collapsed collapsed' : 'panel-collapse collapse'}}">

      <div class="panel-body">
        <table *ngIf="roles && roles.totalItems > 0 && openPanel" class="table">
          <caption class="sr-only">Tabella ruoli</caption>
          <thead>
            <tr>
              <th class="col-xs-3">Nome</th>
              <th class="col-xs-3">Descrizione</th>
              <th class="col-xs-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let role of roles.items">
              <td class="col-xs-3 cell">{{role.name}}</td>
              <td class="col-xs-3 cell">{{role.description}}</td>
              <td class="rightaligned">

                <button type="button" (click)="onSelectRole(role)" class="btn-link">{{labelButton ? labelButton : 'Seleziona'}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>





<div *ngIf="roles && openPanel" class="card-pagination">
  <app-pagination
    (refreshEvent)="onRefresh($event)"
    [totalItems]="roles.totalItems">
  </app-pagination>
</div>
